export default __webpack_public_path__ + "static/media/logo_element.82d7018e.svg";